import React from "react";
import {Image} from 'react-bootstrap';

import "./ProjectCycle.css";

import cycle_img from "../../asset/images/cycle_img.webp";
import cycle_right_bk from "../../asset/images/cycle_right_bk.png";
import cycle_icon_01 from "../../asset/images/cycle_icon_01.png";
import cycle_icon_02 from "../../asset/images/cycle_icon_02.png";
import cycle_icon_03 from "../../asset/images/cycle_icon_03.png";
import cycle_icon_04 from "../../asset/images/cycle_icon_04.png";
import cycle_icon_05 from "../../asset/images/cycle_icon_05.png";
import cycle_icon_06 from "../../asset/images/cycle_icon_06.png";
import cycle_icon_07 from "../../asset/images/cycle_icon_07.png";

//项目周期
class ProjectCycle extends React.Component {
  render() {
    return (
      <div className="cycle">
        <Image src={cycle_img} className="cycle_img" />
        <div className="cycle_content">
          <div className="cycle_left">
            <div className="cycle_left_title">
              高效流程控制，有效保障项目各环节无缝衔接
            </div>
            <div className="cycle_left_paragraph">
              针对节能改造项目的特点，按照信息采集、技术方案制定、方案细化、节能合同商务谈判、项目实施及验收的步骤进行，实施过程中制定符合客户需求的详细流程，并根据项目特点和客户需求量身定制产品，将节能产品组合发挥其优秀的节能率，帮助客户实现理想的收益。
            </div>
          </div>
          <div className="cycle_right">
            <Image src={cycle_right_bk} className="cycle_right_bk" />
            <Image src={cycle_icon_01} className="cycle_icon_01" />
            <Image src={cycle_icon_02} className="cycle_icon_02" />
            <Image src={cycle_icon_03} className="cycle_icon_03" />
            <Image src={cycle_icon_04} className="cycle_icon_04" />
            <Image src={cycle_icon_05} className="cycle_icon_05" />
            <Image src={cycle_icon_06} className="cycle_icon_06" />
            <Image src={cycle_icon_07} className="cycle_icon_07" />
          </div>
        </div>
      </div>
    )
  }
}

export default ProjectCycle
